import { render } from "./Login.vue?vue&type=template&id=5dc1f34c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=5dc1f34c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dc1f34c"

export default script